import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-employee.reducer';

export const TenantEmployeeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantEmployeeEntity = useAppSelector(state => state.tenantEmployee.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantEmployeeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantEmployee.detail.title">TenantEmployee</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.id">Id</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.name">Name</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.email">Email</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.email}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.education">Education</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.education}</dd>
          <dt>
            <span id="training">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.training">Training</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.training}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.experience}</dd>
          <dt>
            <span id="achievements">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.achievements">Achievements</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.achievements}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.dateOfBirth}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.gender}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.bloodGroup}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.active">Active</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.timestampEntry}</dd>
          <dt>
            <span id="exited">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.exited">Exited</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.exited ? 'true' : 'false'}</dd>
          <dt>
            <span id="labServiceType">
              <Translate contentKey="tinyMedicRestApp.tenantEmployee.labServiceType">Lab Service Type</Translate>
            </span>
          </dt>
          <dd>{tenantEmployeeEntity.labServiceType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantEmployee.tenant">Tenant</Translate>
          </dt>
          <dd>{tenantEmployeeEntity.tenant ? tenantEmployeeEntity.tenant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantEmployee.user">User</Translate>
          </dt>
          <dd>{tenantEmployeeEntity.user ? tenantEmployeeEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantEmployee.contactCode">Contact Code</Translate>
          </dt>
          <dd>{tenantEmployeeEntity.contactCode ? tenantEmployeeEntity.contactCode.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-employee" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenant-employee/${tenantEmployeeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantEmployeeDetail;
